'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeScattermapboxIcon = function TraceTypeScattermapboxIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#1d9bfb', d: 'M17.87 20.197l2.827-2.829 6.364 6.364-2.828 2.829z', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { d: 'M27.06 26.56a6 6 0 0 0 0 8.486l8.486-8.485a6 6 0 0 0-8.485 0z', fill: '#fff' }),
        _react2.default.createElement('path', { d: 'M27.06 26.56a6 6 0 0 0 0 8.486l8.486-8.485a6 6 0 0 0-8.485 0z', fill: 'none', stroke: '#1d9bfb', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: '#fff', stroke: '#1d9bfb', d: 'M31.303 30.803l1.415 1.415', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: '#fff', stroke: '#1d9bfb', d: 'M7.968 30.096l7.778-7.778 5.657 5.657-7.778 7.778zM19.8 23.482l-1.142 1.143', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#1d9bfb', d: 'M13.979 24.086l5.657 5.657M12.565 25.5l5.657 5.657m-7.071-4.243l5.657 5.657m-7.072-4.243l5.657 5.657', strokeMiterlimit: '10' }),
        _react2.default.createElement('path', { fill: '#fff', stroke: '#1d9bfb', d: 'M36.254 13.125l-7.779 7.779-5.656-5.657 7.778-7.778zM24.232 19.49l1.414-1.415', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#1d9bfb', d: 'M24.586 13.479l5.657 5.657M26 12.065l5.657 5.657m-4.243-7.071l5.657 5.657m-4.243-7.072l5.657 5.657', strokeMiterlimit: '10' }),
        _react2.default.createElement('path', { d: 'M16.454 15.954a2 2 0 0 1 2.829 0l1.414 1.414-2.829 2.829-1.414-1.415a2 2 0 0 1 0-2.828z', fill: 'none', stroke: '#1d9bfb', strokeMiterlimit: '10', strokeWidth: '2' })
    );
};

exports.default = TraceTypeScattermapboxIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeScattermapboxIcon.js
// module id = 727
// module chunks = 0